import { generateCorrelationId } from '@src/helpers/generateCorrelationId';
import host from "./apiConfig";

const fetchWithTimeout = async (path, options = {}, time = 5000) => {
  const uri = host.concat(path);
  const controller = new AbortController();
  if (options.headers && !(options.headers instanceof Headers)) {
    options.headers = new Headers(options.headers);
  }
  else if(!options.headers){
    options.headers = new Headers();
  }
  //always include correlation ID in every API request;
  if(!options.headers.get('X-Correlation-ID')){
    options.headers.append('X-Correlation-ID', generateCorrelationId());
  }
  const config = { ...options, signal: controller.signal };
  // set timeout and abort fetch when expired
  setTimeout(() => {
    controller.abort();
  }, time);
  return await fetch(uri, config)
    .then((response) => {
      // check that the response is in the 200 range.
      if (!response.ok) {
        throw new Error(`${response.status}: ${response.statusText}`);
      }
      
      return response;
    })
    .catch((error) => {
      if (error.name === "AbortError") {
        throw new Error("Response timed out");
      }
      throw new Error(error.message);
    });
};

export default fetchWithTimeout;
